import type { LoginStep } from '../login-flow';

/**
 * Maps login steps to/from the URL path segment under `/login`, so the address
 * bar, refresh, browser back/forward, and direct links all reflect the step —
 * matching the Ember login's sub-routes. The email step is the bare `/login`.
 */
const STEP_TO_SEGMENT: Record<LoginStep, string> = {
  email: '',
  password: 'password',
  two_factor_authentication: 'two_factor_authentication',
  '2fa_email_link': '2fa_email_link',
  sso: 'sso',
  choose_user: 'choose_user',
};

const SEGMENT_TO_STEP = new Map<string, LoginStep>(
  // oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
  Object.entries(STEP_TO_SEGMENT).map(([step, segment]) => [segment, step as LoginStep]),
);

export function stepFromSplat(splat: string | undefined): LoginStep {
  const segment = (splat ?? '').split('/')[0];
  return SEGMENT_TO_STEP.get(segment) ?? 'email';
}

export function splatForStep(step: LoginStep): string {
  return STEP_TO_SEGMENT[step];
}
